import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HashLoader from "react-spinners/ClipLoader";
import AXIOS from "../../../config/axios";
import fetchSizeList from "../../../api/lockers/fetchSizeList";
import SuffolkLockerSelect from "../Pickup/SuffolkLockerSelect";

const LockerView = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const isAuthenticated = useSelector((state) => state.user);
  const [allowed, setAllowed] = useState(false);
  const [checked, setChecked] = useState(false);
  const [data, setData] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [doorInputs, setDoorInputs] = useState({});

  useEffect(() => {
    const role = String(isAuthenticated?.role || "").toLowerCase();
    if (role === "superadmin" || !isAuthenticated?.site_id) {
      setAllowed(false);
      setChecked(true);
      return undefined;
    }
    let stopped = false;
    fetch(`${url}/api/sites/getSite/${isAuthenticated.site_id}`)
      .then((res) => res.json())
      .then((json) => {
        if (stopped) return;
        setAllowed(
          String(json?.site?.slug || "").toLowerCase() === "suffolkcounty"
        );
        setChecked(true);
      })
      .catch(() => {
        if (!stopped) {
          setAllowed(false);
          setChecked(true);
        }
      });
    return () => {
      stopped = true;
    };
  }, [isAuthenticated?.role, isAuthenticated?.site_id, url]);

  useEffect(() => {
    if (!allowed) return undefined;
    setIsLoading(true);
    AXIOS.get("/lockers/list?page=1&limit=100")
      .then((res) => {
        setData(res.data.lockers || []);
      })
      .catch(() => setData([]))
      .finally(() => setIsLoading(false));
    fetchSizeList().then((sizeData) => {
      if (sizeData?.data) setSizes(sizeData.data);
    });
    return undefined;
  }, [allowed]);

  useEffect(() => {
    if (!allowed) return undefined;
    let stopped = false;
    const loadDoorStatus = () => {
      AXIOS.get("/lockers/door/status")
        .then((res) => {
          if (!stopped && res.data?.inputs) setDoorInputs(res.data.inputs);
        })
        .catch(() => {});
    };
    loadDoorStatus();
    const timer = setInterval(loadDoorStatus, 4000);
    return () => {
      stopped = true;
      clearInterval(timer);
    };
  }, [allowed]);

  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap">
                <h3>Lockers View</h3>
                <p>Suffolk County locker cabinet</p>
              </div>
            </div>
          </div>
        </div>
        {checked && !allowed && (
          <p>This view is only for the Suffolk County site.</p>
        )}
        {allowed && (
          <div className="d-flex justify-content-center mt-3">
            {isLoading ? (
              <div className="text-center py-5">
                <HashLoader color="#0b0d41" loading size={40} />
              </div>
            ) : (
              <SuffolkLockerSelect
                sizes={sizes}
                siteLockers={data}
                doorInputs={doorInputs}
                sensorColors
                viewOnly
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LockerView;
